import { ReactNode, CSSProperties } from 'react';

export type AlertVariant = 'danger' | 'warning' | 'info' | 'success' | 'neutral';

interface AlertBannerProps {
  variant?: AlertVariant;
  icon?: string;
  children: ReactNode;
  role?: string;
  style?: CSSProperties;
}

const VARIANT_CLASS: Record<AlertVariant, string> = {
  danger: 'acc-alert-banner--danger',
  warning: 'acc-alert-banner--warning',
  info: 'acc-alert-banner--info',
  success: 'acc-alert-banner--success',
  neutral: 'acc-alert-banner--neutral',
};

const DEFAULT_VARIANT_ICON: Partial<Record<AlertVariant, string>> = {
  danger: '!',
  warning: '!',
};

export default function AlertBanner({
  variant = 'neutral',
  icon,
  children,
  role,
  style,
}: AlertBannerProps) {
  const ariaRole = role ?? (variant === 'danger' || variant === 'warning' ? 'alert' : undefined);
  const renderedIcon = icon ?? DEFAULT_VARIANT_ICON[variant];

  return (
    <div
      role={ariaRole}
      className={['acc-alert-banner', VARIANT_CLASS[variant]].join(' ')}
      style={style}
    >
      {renderedIcon && <span className="acc-alert-banner__icon" aria-hidden="true">{renderedIcon}</span>}
      <div className="acc-alert-banner__body">{children}</div>
    </div>
  );
}
